import ChannelFormPublish from './ChannelFormPublish'

export default ChannelFormPublish
